import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'wd-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {}
